import { StickySaleTagSlice } from "./types";

export const initialState: StickySaleTagSlice = {
	saleTags: [],
	closedStickyTags: [],
	activeTags: [],
	closedMenuSaleTags: [],
	showMegaMenuIndicator: false
};
